var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StatCardRow"},[(_vm.isLoading)?_vm._l((_vm.placeholderCount),function(i){return _c('RPBaseStatCard',{key:i,staticClass:"StatCardRow__placeholder",attrs:{"status":_vm.status}})}):[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }